function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-iconid": 326970,
    "data-svgname": "Checkmark sharp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    fill: "#344054",
    style: {
      fill: "rgb(52, 64, 84)"
    },
    id: titleId
  }, "ionicons-v5-e") : title ? /*#__PURE__*/React.createElement("title", {
    fill: "#344054",
    style: {
      fill: "rgb(52, 64, 84)"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "416 128 192 384 96 288",
    style: {
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 44,
      stroke: "rgb(52, 64, 84)",
      fill: "none"
    },
    stroke: "#344054",
    strokeWidth: 1.5,
    fill: "none"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.178353afc44c0703b30d5447b083c635.svg";
export { ForwardRef as ReactComponent };